"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var QueryContext = /** @class */ (function () {
    function QueryContext(contextValues) {
        if (contextValues === void 0) { contextValues = new Map(); }
        this.contextValues = new Map(contextValues);
    }
    QueryContext.prototype.getValue = function (key) {
        return this.contextValues.get(key);
    };
    QueryContext.prototype.setValue = function (key, value) {
        this.contextValues.set(key, value);
        return this;
    };
    QueryContext.prototype.getContextKeys = function () {
        return Array.from(this.contextValues.keys());
    };
    QueryContext.prototype.getContextEntries = function () {
        return new Map(this.contextValues);
    };
    return QueryContext;
}());
exports.default = QueryContext;
